import { NgModule } from "@angular/core";
import { CommonModule} from '@angular/common';


import {HomeWorkSocialTab} from "./home-work-social-tab/tab";
import {ComponentSoical} from './home-work-social/social';
import {ComponentEvaluate} from './home-work-evaluate/evaluate';
import {SharedModule} from '../../component/shareModule';


@NgModule({
  imports: [CommonModule, SharedModule],
    declarations:[
        ComponentSoical,
        HomeWorkSocialTab,
        ComponentEvaluate
    ],
    exports:[
        HomeWorkSocialTab,
        ComponentSoical,
        ComponentEvaluate
    ]
})

export class HomeWorkShowModule{

}




// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-show.module.ts